import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/(auth)/privacy")({
  component: RouteComponent,
  loader: async () => {
    // do something with params.postId
    const resposne = await fetch(
      "https://api.modulusseventeen.com/api/v1/preference/privacy-policy"
    );
    return await resposne.json();
  },
});

function RouteComponent({}) {
  const {
    data: {
      value: { description },
    },
  } = Route.useLoaderData();

  return (
    <div
      className="px-10 py-24"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
}
